import { Component, type ErrorInfo, type ReactNode } from "react";
import { SplitPanelEmptyState } from "./split-panel-empty-state";

interface Props {
  children: ReactNode;
}
interface State {
  hasError: boolean;
}

export class SplitErrorBoundary extends Component<Props, State> {
  public state: State = { hasError: false };

  // eslint-disable-next-line
  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Split Screen Error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) return <SplitPanelEmptyState moduleNotFound />;
    return this.props.children;
  }
}
